interface ICategoryEdge {
  node: {
    backgroundImage?: {
      url: string;
    } | null;
    slug?: string;
    products?: {
      edges?: Array<{
        node: {
          name?: string;
          slug?: string;
          thumbnail?: {
            url: string;
          } | null;
        };
      }> | null;
      totalCount: number;
    } | null;
  };
}

interface ICategoryConnection<T extends ICategoryEdge> {
  edges?: T[] | null;
}

export const visibleHomeCategoryEdges = <T extends ICategoryEdge>(
  categories?: ICategoryConnection<T> | null
): T[] =>
  categories && categories.edges
    ? categories.edges.filter(
        ({ node }) => Boolean(node.products) && node.products.totalCount > 0
      )
    : [];

export const categoryProductCountLabel = (count: number): string =>
  `${count} ${count === 1 ? "product" : "products"}`;

const PREFERRED_CATEGORY_PRODUCT_SLUGS: Record<string, string[]> = {
  blades: ["andis-cordless-t-outliner-li-replacement-t-blade-stainless-steel"],
  "combs-brushes-guards": ["andis-blade-brush"],
  "sanitation-disposables": ["andis-cool-care-plus-can"],
  "styling-products": ["black-ice-nude-barber-pencil"],
};

export const categoryImageUrl = (category: ICategoryEdge["node"]): string => {
  if (category.backgroundImage && category.backgroundImage.url) {
    return category.backgroundImage.url;
  }

  const products =
    category.products && category.products.edges
      ? category.products.edges
          .map(({ node }) => node)
          .filter(product =>
            Boolean(product.thumbnail && product.thumbnail.url)
          )
      : [];
  const preferredSlugs =
    PREFERRED_CATEGORY_PRODUCT_SLUGS[category.slug || ""] || [];

  for (const slug of preferredSlugs) {
    const product = products.find(candidate => candidate.slug === slug);
    if (product && product.thumbnail) {
      return product.thumbnail.url;
    }
  }

  const firstProductWithImage = products[0];
  return firstProductWithImage && firstProductWithImage.thumbnail
    ? firstProductWithImage.thumbnail.url
    : "";
};
